/* Membership-freebie eligibility prefetch.

   Starts the deciding API call as early as possible so the verdict is usually
   resolved before the deferred monthly-freebie-membership.js needs it — that
   script adopts window.__wbnEligibilityPrefetch only when the customer id
   still matches, and falls back to issuing its own request otherwise.

   Loaded `async` from <head> (see layout/theme.liquid) rather than inlined, so
   it never blocks head parsing. Configuration comes from the script tag's data
   attributes, which keeps theme.liquid the single source of truth for both the
   endpoint and the logged-in customer id:

     <script src="{{ 'membership-freebie-prefetch.js' | asset_url }}"
             data-eligibility-url="…"
             data-customer-id="{{ customer.id }}"
             async></script>

   window.__wbnEligibilityUrl is published here for monthly-freebie-membership.js;
   that asset keeps its own literal fallback in case this file is ever removed. */
(function () {
  var script = document.currentScript;
  if (!script) { return; }

  var url = script.getAttribute('data-eligibility-url');
  if (!url) { return; }
  window.__wbnEligibilityUrl = url;

  try {
    var id = script.getAttribute('data-customer-id') ||
      localStorage.getItem('kp_customer_id');
    if (!id) { return; }
    window.__wbnEligibilityPrefetchCustomer = String(id);
    window.__wbnEligibilityPrefetch = fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId: String(id) })
    });
  } catch (e) { /* prefetch is best-effort; the asset fetches for itself */ }
})();
